import { css } from '@emotion/react';
import { useState } from 'react';

import { createSilentWav } from '@/lib/audio/silence-generator';
import { darkTheme } from '@/theme/dark-theme';

export interface IOSAudioUnlockProps {
  audioElements: [HTMLAudioElement, HTMLAudioElement];
  onUnlocked: () => void;
}

export function IOSAudioUnlock({ audioElements, onUnlocked }: IOSAudioUnlockProps) {
  const [error, setError] = useState(false);

  async function handleClick() {
    try {
      const blob = createSilentWav(500);
      const blobUrl = URL.createObjectURL(blob);

      for (const el of audioElements) {
        el.src = blobUrl;
        el.load();
      }

      await Promise.all(audioElements.map((el) => el.play()));

      for (const el of audioElements) {
        el.pause();
      }

      URL.revokeObjectURL(blobUrl);
      onUnlocked();
    } catch {
      setError(true);
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      css={css`
        position: fixed;
        inset: 0;
        z-index: 50;
        background: ${darkTheme.overlay};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      `}
    >
      <p
        css={css`
          color: ${darkTheme.text};
          font-size: 24px;
          text-align: center;
          padding: 0 24px;
        `}
      >
        {error ? 'Tap again to enable audio' : 'Tap anywhere to enable audio'}
      </p>
    </div>
  );
}
